import { render } from "./DocumentImageOverview.vue?vue&type=template&id=8a319ab8"
import script from "./DocumentImageOverview.vue?vue&type=script&lang=js"
export * from "./DocumentImageOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/flow/evaluate/DocumentImageOverview.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8a319ab8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8a319ab8', __exports__)) {
    api.reload('8a319ab8', __exports__)
  }
  
  module.hot.accept("./DocumentImageOverview.vue?vue&type=template&id=8a319ab8", () => {
    api.rerender('8a319ab8', render)
  })

}


export default __exports__